import { OrderProductRootGroup } from 'src/adminPanel/components/order/dialog/OrderProductsDialog';
import callApi from 'src/api';

export const fetchProductGroups = (rootGroup: OrderProductRootGroup) => {
    const endpoint = `/api/productgroups/${rootGroup}`;
    return callApi(endpoint);
};
